module.exports = __webpack_public_path__ + "static/nkbmmobile-879a006e2e534673dc406402d2ff042d.png";